import { defineNuxtPlugin } from "nuxt/app";
import { initSentry, addDynamicImportBreadcrumb, captureException } from "@/services/analytics/sentry";

export default defineNuxtPlugin((nuxtApp) => {
  initSentry(nuxtApp.vueApp);

  nuxtApp.vueApp.config.errorHandler = (err, _instance, info) => {
    captureException(err);
    console.error("[Vue]", info, err);
  };

  window.addEventListener("unhandledrejection", (event) => {
    captureException(event.reason);
  });

  // Nuxt wraps dynamic imports through its own runtime helper; the event name
  // differs from Vite's vite:preloadError but the breadcrumb tap still applies.
  window.addEventListener("vite:preloadError", (event) => {
    addDynamicImportBreadcrumb((event as Event & { payload: unknown }).payload);
  });
});
